import { ScreenshotValidationOptions, WopeeOptions } from '../../../core/domain/configuration/config.interface.js';
import { ConfigPort } from '../../../core/ports/configPort/configPort.js';
import 'dotenv/config';

export class EnvConfigAdapter extends ConfigPort {
  _loadConfig(): WopeeOptions {
    const screenshotValidationOptions = {
      apiKey: process.env?.WOPEE_API_KEY,
      apiUrl: process.env?.WOPEE_API_URL,
      branchName: process.env?.WOPEE_BRANCH_NAME,
      browser: process.env?.WOPEE_BROWSER,
      comment: process.env?.WOPEE_COMMENT,
      customTags: process.env?.WOPEE_CUSTOM_TAGS,
      device: process.env?.WOPEE_DEVICE,
      enableSoftAssert: process.env?.WOPEE_ENABLE_SOFT_ASSERT,
      // `|| undefined` because an exported-but-empty variable arrives as '',
      // and Number('') is 0 — which would silently mean "no retries" and "no
      // timeout" rather than "not configured". The SDK never reads the
      // environment itself, so blank has to be normalised here.
      maxRetries: process.env?.WOPEE_API_MAX_RETRIES || undefined,
      os: process.env?.WOPEE_OS,
      pixelToPixelDiffTolerance: process.env?.WOPEE_PIXEL_TO_PIXEL_DIFF_TOLERANCE,
      projectUuid: process.env?.WOPEE_PROJECT_UUID,
      requestTimeoutMs: process.env?.WOPEE_API_TIMEOUT_MS || undefined,
      screenshotValidationEnabled: process.env?.WOPEE_SCREENSHOT_VALIDATION_ENABLED,
      viewport: process.env?.WOPEE_VIEWPORT,
      collectPageContent: process.env?.WOPEE_COLLECT_PAGE_CONTENT,
      baselineBranchName: process.env?.WOPEE_BASELINE_BRANCH_NAME,
      suiteUuid: process.env?.WOPEE_SUITE_UUID,
    };

    return { screenshotValidation: screenshotValidationOptions as any as ScreenshotValidationOptions };
  }
}
